import { Component, Input } from "@angular/core";
import { NzTimelineComponent, NzTimelineItemComponent } from "ng-zorro-antd/timeline";
import { EventLogInterface } from "../../models/event-log.interface";
import { CommonUtils } from "../../utils/common-utils";
import { DateUtils } from "../../utils/date-utils";
import { NoDataComponent } from "../no-data/no-data.component";

@Component({
  selector: 'app-activity-log-timeline',
  standalone: true,
  imports: [
    NzTimelineComponent,
    NzTimelineItemComponent,
    NoDataComponent
  ],
  templateUrl: './activity-log-timeline.component.html',
  styleUrl: './activity-log-timeline.component.scss'
})
export class ActivityLogTimelineComponent {
  @Input() activityLogData: EventLogInterface[] = [];
  protected readonly Object = Object;
  protected readonly CommonUtils = CommonUtils;
  protected readonly Date = Date;
  protected readonly DateUtils = DateUtils;
}
